module.exports = __webpack_public_path__ + "static/img/hujiao.5c433fc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bottom/blue/hujiao.png
// module id = endb
// module chunks = 24